import { render } from "./TwilioRedirectCallDialog.vue?vue&type=template&id=bceeecc8"
import script from "./TwilioRedirectCallDialog.vue?vue&type=script&lang=js"
export * from "./TwilioRedirectCallDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__